import { applyCreateDraftResult } from './applyCreateDraftResult';
import { upsertListing } from './entityAdapter';
import { setActiveTabByProductChannel, setSelectedChannelByProduct } from './uiAdapter';
import { LISTING_STATUS } from '../constants/listingStatus';

/**
 * Upserts listing channel entries from create-draft / publish-directly API results.
 */
const applyListingProductsToState = (state, { productId, listingProducts = [] }) => {
  const product = state.items.find(({ _id }) => _id === productId);
  if (!product || !listingProducts.length) return;

  listingProducts.forEach(({
    channelId, listingProduct, variants = [], fromCreateDraft,
  }) => {
    if (fromCreateDraft) {
      applyCreateDraftResult(state, {
        productId,
        channelId,
        listing: listingProduct,
        variants,
      });
      return;
    }

    // Publish-directly should show the live result. Preserve-draft keeps listingStatus DRAFT
    // while writing `live` — still switch UI to Published when live exists.
    const activeTab = listingProduct.live
      ? LISTING_STATUS.PUBLISHED
      : listingProduct.listingStatus;
    setActiveTabByProductChannel(state, productId, channelId, activeTab);

    upsertListing(state, {
      ...listingProduct,
      masterProductId: productId,
    });
  });

  const lastChannelId = listingProducts[listingProducts.length - 1]?.channelId;
  if (lastChannelId) {
    setSelectedChannelByProduct(state, productId, lastChannelId);
  }
};

export default applyListingProductsToState;
